import cx from 'classnames'
import { useState } from 'react'

import type { MediaComponentProps } from './MarkdownMedia'

export const MarkdownImage = ({ src, alt }: MediaComponentProps) => {
  const [isMountedInTable, setIsMountedInTable] = useState(false)

  const handleImageMounted = (ref: HTMLImageElement | null) => {
    if (ref && ref.parentElement?.tagName === 'TD') {
      setIsMountedInTable(true)
    }
  }

  return (
    <img
      src={src}
      alt={alt}
      className={cx('max-w-full h-auto rounded-lg shadow-md', {
        'w-full!': !isMountedInTable,
      })}
      ref={handleImageMounted}
    />
  )
}
